import axios from 'axios';
import config from '../config';

const TargetConnectionService = {
  get: async () => {
    const response = await axios.get(`${config.apiBaseUrl}/target-connection`);
    return response.data;
  },

  create: async (data) => {
    const response = await axios.post(`${config.apiBaseUrl}/target-connection`, data);
    return response.data;
  },

  update: async (data) => {
    const response = await axios.put(`${config.apiBaseUrl}/target-connection`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await axios.delete(`${config.apiBaseUrl}/target-connection/${id}`);
    return response.data;
  },
};

export default TargetConnectionService;
